import LazyLoad from 'vanilla-lazyload';

export class LazyImage {
	/**
	 * used for singleton creation
	 * @type {LazyImage}
	 */
	static instance = null;
	/**
	 * @type {LazyLoad}
	 */
	_imgLoader = null;
	/**
	 * @type {LazyLoad}
	 */
	_bgLoader = null;

	constructor() {
		if (LazyImage.instance) {
			return LazyImage.instance;
		}

		LazyImage.instance = this;
	}

	static getInstance() {
		if (!LazyImage.instance) {
			LazyImage.instance = new LazyImage();
		}

		return LazyImage.instance;
	}

	init() {
		this._initImgLoader();
		this._initBgLoader();
		this._addSpinners();
	}

	/**
	 * Force updates the Image Loader, used when content is loaded asynchronously
	 */
	update() {
		if (!this._imgLoader) {
			console.warn('Image Loader not initialized.');
			return;
		}

		this._imgLoader.update();
		this._addSpinners();
	}

	/**
	 * Adds a standard loading spinner to images
	 * @private
	 */
	_addSpinners() {
		document.querySelectorAll('.js-lazy-image--loader').forEach((el) => {
			const hasLoader = el.parentElement.querySelector('.c-lazy-image__loader');

			if (hasLoader) {
				return;
			}

			const loaderEl = document.createElement('img');
			loaderEl.classList.add('c-lazy-image__loader');
			loaderEl.src = '/assets/img/loader-medium_white@2x.gif';
			loaderEl.ariaHidden = "true";

			el.parentElement.appendChild(loaderEl);
			el.parentElement.classList.add('c-lazy-image--has-loader');
		});
	}

	/**
	 * Initializes the image element loader
	 * @private
	 */
	_initImgLoader() {
		this._imgLoader = new LazyLoad({
			elements_selector: '.js-lazy-image',
			class_loading: 'is-loading',
			class_loaded: 'is-loaded',
			class_error: 'is-error',
			threshold: 300,
			callback_loaded: function(el) {
				// remove placeholder image
				const placeholder = el.parentElement.querySelector('.c-lazy-image__placeholder');

				setTimeout(function() {
					if (placeholder) {
						placeholder.classList.add('is-loading-done');
					}
				}, 1000);
			},
		});
	}

	/**
	 * Initializes the background image loader
	 * @private
	 */
	_initBgLoader() {
		this._bgLoader = new LazyLoad({
			elements_selector: '.js-lazy-image-bg',
			class_loading: 'is-loading',
			class_loaded: 'is-loaded',
			class_error: 'is-error',
		});
	}
}

window.LazyImage = LazyImage.getInstance();

window.LazyImage.init();



